<template>
  <div class="cmp-sub-tab-wrap" :class="{'mobile':_isMobile}">
    <div ref="myTab" class="cmp-sub-tab" :class="{'pc': !_isMobile}">
      <div class="item g-pointer" :class="{'active': activeTab===item.val}" v-for="(item, index) in tabList" :key="index" @click="clickTab(item, index)">{{item.name}}</div>

      <div class="tab-line"></div>
      <!-- <div class="tab-line" :style="{height: 'calc(100vh - '+subHeight+')'}"></div> -->
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      tabs: {
        type: Array,
        default() {
          return []
        }
      },
      subHeight: {
        type: String,
        default: '760px'
      },
      activeVal: {
        type: String,
        default: '1'
      }
    },
    watch: {
      tabs(newVal) {
        this.tabList = newVal
      },
      activeVal(newVal) {
        this.activeTab = newVal
      }
    },
    data() {
      return {
        activeTab: this.activeVal || '1',
        tabList: this.tabs,
        currentIndex: 0
        // tabList: [
        //   {
        //     name: '展厅实景',
        //     val: '1',
        //   },
        //   {
        //     name: '展品详情',
        //     val: '2'
        //   }
        // ],
      }
    },
    methods: {
      clickTab(item, index) {
        if(this.activeTab !== item.val) {
          this.currentIndex = index
          this.activeTab = item.val
          this.$emit('eventTabClick', item.val, index)
          this.getTabItemWidth()
        }
      },
      // 获取左移动位置
      getTabItemWidth() {
        let arr = this.$refs.myTab.getElementsByClassName('item')
        let lineLeft = 0  // 前面的宽度总和
        let currentWidth = 0 // 当前元素宽度
        for (let i = 0; i < arr.length; i++) {
          if (i < this.currentIndex) {
            lineLeft += arr[i].clientWidth
          } else if (i == this.currentIndex) {
            currentWidth = arr[i].clientWidth
          } else {
            break
          }
        }

        lineLeft = lineLeft + currentWidth / 2
        let containerWidth = this.$refs.myTab.clientWidth
        let scrollLeft = lineLeft - containerWidth / 2 + 80

        // console.log(lineLeft)
        // console.log(containerWidth)
        // console.log(scrollLeft)
        this.$refs.myTab.scrollLeft = scrollLeft
      }
    }
  }
</script>

<style lang="scss" scoped>
.cmp-sub-tab {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 24px;
  color: #3D3D3D;
  white-space: nowrap;
  overflow-x: auto;
  // border-top: solid 1px rgba(#000000, 0.1);
  // border-bottom: solid 1px rgba(#000000, 0.1);
  padding: 26px 0;
  // margin-bottom: 30px;
  .item {
    width: 238px;
    height: 42px;
    margin-bottom: 25px;
    font-size: 16px;
    color: $primary;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url(~@images/sub-tab-bg.png) no-repeat center center;
    background-size: 100% 100%;
    // }
    &.active {
      background: url(~@images/sub-tab-bg-active.png) no-repeat center center;
      background-size: 100% 100%;
      color: #fff;
    }
  }

  &::-webkit-scrollbar {  
    display: none;
  }   

  &.pc {
    flex-direction: column;
  }
}
</style>